// src/contexts/UserContext.js
import { createContext, useContext } from "react";

export const UserContext = createContext(null);

/**
 * Returns true if the logged-in user has the given permission codename.
 *
 * Safe to call before the user object loads — returns false until Name arrives.
 * Admins always return true (permissions contains '*').
 *
 * NOTE: Do NOT use this hook inside Layout.js itself — Layout owns the
 * UserContext.Provider, so context reads there return null on first render.
 * Use the hasPerm() helper in Layout.js directly against the Name state.
 * All child components (Home, etc.) rendered inside <Outlet /> are safe
 * to use these hooks normally.
 */
export const usePermission = (codename) => {
    const user = useContext(UserContext);
    if (!user?.permissions) return false;
    if (user.permissions.includes('*')) return true;    // is_admin wildcard
    return user.permissions.includes(codename);
};

/**
 * Returns true if the user has ANY of the supplied codenames.
 * Useful for showing a nav section when at least one sub-permission is held.
 */
export const useHasAnyPerm = (...codenames) => {
    const user = useContext(UserContext);
    if (!user?.permissions) return false;
    if (user.permissions.includes('*')) return true;
    return codenames.some(c => user.permissions.includes(c));
};